import { useFilterOptions } from './useFiltersOptions';
import sortOptions from '@/constants/sortOptions';

export const usePendingFilterStore = useFilterOptions(
  'pendingFilterStore',
  'api/transport-requests/manage/Pending-Offer',
  {
    sortObj: sortOptions.recentlyUpdated
  },
);
